import type { Keg, KegStatus } from '@/types'

// Colour encodes state, mapped onto the Kraft palette (cf. "Règle de la Terre
// Cuite"): leaf = at the brewery / clean, mustard = out at a customer, flame =
// needs action (repair / lost), ink = in motion.
const STATUS_DOT_COLOR: Record<KegStatus, string> = {
  in_stock: 'bg-leaf',
  washing: 'bg-leaf',
  delivered: 'bg-mustard',
  in_transit: 'bg-ink-faint',
  repair: 'bg-flame',
  lost: 'bg-flame-deep',
}

export function KegStatusBadge({ keg, className = '' }: { keg: Keg; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span className={`h-2 w-2 rounded-full ${STATUS_DOT_COLOR[keg.status]}`} />
      {keg.status_label}
    </span>
  )
}
